import location from './location';
import multipleTabs from './multipleTabs';
import whereabouts from './whereabouts';
import pinning from './pinning';

import areas from './areas';

import rooms from './rooms';

export default {
	// namespaced: true,
	modules: {
		location, multipleTabs, whereabouts, pinning,
    areas,
    rooms
	}
}
